import React, { useState } from "react";
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import CardHeader from "@mui/material/CardHeader";
import Box from "@mui/material/Box";
import StarIcon from "@mui/icons-material/StarBorder";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import NutritionModal from "./nutrition";
import MobilityModal from "./mobility";
import OnlineCoaching from "./online";

const tiers = [
  {
    title: "Complimentary Session",
    description: [
      "1. 1 on 1 Assessment",
      "2. BF & Metabolic Analysis",
      "3. See where you Health and Fitness Level is",
    ],
    buttonText: "Schedule now!",
    buttonVariant: "outlined",
    href: "/schedule",
  },
  {
    title: "Nutrition",
    description: [
      "1. Full Custom Plan",
      "2. Detailed For The Client",
      "3. Help/advice at any time",
      "4. Weekly Accountability Check-Ins",
      "4. Blood work driven",
    ],
    buttonText: "Learn More",
    buttonVariant: "outlined",
  },
  {
    title: "Mobility",
    description: [
      "1. Work On Flexibility",
      "2. Feel Better Again",
      "3. Lower Stress",
      "4. Improve Mood",
      "5. Prevent Injury",
    ],
    buttonText: "Learn More",
    buttonVariant: "outlined",
  },
  {
    title: "Online Health Coaching",
    price: "NOW $99", // Adjust the price as per your pricing strategy
    description: [
      "1. Personalized Workout Plans",
      "2. Nutrition and Diet Tracking",
      "3. Regular Progress Check-ins",
      "4. Direct Messaging with Your Coach",
      "5. Integration with Fitness Trackers",
      "6. Access to a Library of Exercises",
      "7. Customizable Goals and Reminders",
      "8. Support and Motivation",
      "9. Convenient and Flexible Scheduling",
      "10. Safe and Effective Training Techniques",
    ],
    buttonText: "Get Started",
    buttonVariant: "outlined",
  },
];

const cardStyles = {
  backgroundColor: "black", // Set background color to black
  color: "magenta", // Set text color to magenta
  border: "1px solid black",
  boxShadow: "0 0 8px 2px white", // Add white blur around the border
  textAlign: "center",
  margin: "20px",
  padding: "20px",
  fontFamily: "cursive",
  display: "inline-block",
  width: "300px",
};

function PricingContent() {
  const [openModalNutrition, setOpenModalNutrition] = useState(false);
  const [openModalMobiliity, setOpenModalMobility] = useState(false);
  const [openModalOnline, setOpenModalOnline] = useState(false);

  const handleOpenModalNutrition = () => setOpenModalNutrition(true);
  const handleCloseModalNutrition = () => setOpenModalNutrition(false);

  const handleOpenModalMobility = () => setOpenModalMobility(true);
  const handleCloseModalMobility = () => setOpenModalMobility(false);

  const handleOpenModalOnline = () => setOpenModalOnline(true);
  const handleCloseModalOnline = () => setOpenModalOnline(false);

  return (
    <React.Fragment>
      <div style={{ background: "black" }}>
        <Container maxWidth="xl" component="main">
          <Typography
            variant="h4"
            sx={{
              color: "magenta", // Change color to magenta for a vibrant look
              textAlign: "center",
              my: 4,
              fontWeight: "bold", // Make the font bold
              textTransform: "uppercase", // UPPERCASE letters for emphasis
              fontFamily: "Arial, sans-serif", // Use a more modern font family
              letterSpacing: "0.1rem", // Add some letter spacing for a sophisticated touch
              textShadow: "2px 2px 4px rgba(0,0,0,0.2)", // Add a subtle shadow for depth
            }}
          >
            Services
          </Typography>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "center", // Center the cards horizontally
              flexWrap: "wrap", // Allow cards to wrap as needed
              gap: "20px", // Add gap between cards for better spacing
              overflowX: "auto",
              p: 3,
              "&::-webkit-scrollbar": {
                display: "none",
              },
            }}
          >
            {tiers.map((tier, idx) => (
              <Card
                key={idx}
                sx={{
                  ...cardStyles,
                  boxShadow: "0 0 8px 2px white", // Match boxShadow to provided style
                  width: "100%", // Adjust width as necessary
                  maxWidth: "345px", // Set a max-width for the cards
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between", // Distribute space evenly within the card
                }}
              >
                <CardHeader
                  title={`${tier.title} ${tier.price ? `${tier.price}` : ""}`}
                  subheader={tier.subheader}
                  titleTypographyProps={{ align: "center" }}
                  action={
                    tier.title === "1 on 1 Personal Training" ? (
                      <StarIcon />
                    ) : null
                  }
                  subheaderTypographyProps={{ align: "center" }}
                  sx={{
                    backgroundColor: "black",
                    borderBottom: "1px solid purple",
                  }}
                />
                <CardContent>
                  <ul>
                    {tier.description.map((line, idx) => (
                      <Typography component="li" align="left" key={idx}>
                        {line}
                      </Typography>
                    ))}
                  </ul>
                </CardContent>
                <CardActions>
                  <Button
                    fullWidth
                    href={tier.href}
                    variant={tier.buttonVariant}
                    sx={{
                      backgroundColor: "purple",
                      color: "white",
                      "&:hover": {
                        backgroundColor: "darkpurple",
                      },
                    }}
                    onClick={() => {
                      if (tier.title === "Nutrition") {
                        handleOpenModalNutrition();
                      } else if (tier.title === "Mobility") {
                        handleOpenModalMobility();
                      } else if (tier.title === "Online Health Coaching") {
                        handleOpenModalOnline();
                      }
                    }}
                  >
                    {tier.buttonText}
                  </Button>
                </CardActions>
              </Card>
            ))}
          </Box>
        </Container>
      </div>
      <NutritionModal
        open={openModalNutrition}
        handleClose={handleCloseModalNutrition}
      />
      <MobilityModal
        open={openModalMobiliity}
        handleClose={handleCloseModalMobility}
      />
      <OnlineCoaching
        open={openModalOnline}
        handleClose={handleCloseModalOnline}
      />
    </React.Fragment>
  );
}

export default function Pricing() {
  return <PricingContent />;
}
